const API_ENDPOINTS = Object.freeze({
  analysis: {
    list: "/api/analysis/",
  },
  predictions: {
    pancreaticCancerStage: "/api/predictions/pancreatic/predict",
    asthma: "/api/predictions/asthma/predict",
    osteoporosis: "/api/predictions/osteoporosis/predict",
    hypertension: "/api/predictions/hypertension/predict",
    diabetes: "/api/predictions/diabetes/predict",
    cardiovascular: "/api/predictions/cardiovascular/predict",
    liver: "/api/predictions/liver/predict",
    heartDisease: "/api/predictions/heart-disease/predict",
    kidney: "/api/predictions/kidney/predict",
    alzheimers: "/api/predictions/alzheimers/predict",
    breastCancer: "/api/predictions/breast-cancer/predict",
  },
});

export const getPredictionEndpoint = (key) =>
  API_ENDPOINTS.predictions[key];

export default API_ENDPOINTS;

